import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import DynamicLayout from "./components/dynamic-layout";
import { LayoutProvider } from "./contexts/layout-context";
import rawData from "./data/setup.json";
import "./index.css";
import AgreementsPage from "./pages/agreements-page";
import ExamsFaqPage from "./pages/exams-faq-page";
import HomePage from "./pages/home-page";
import ResultsPage from "./pages/results-page";
import type { Data } from "./types/data";

const setup: Data = rawData;
const isShowcaseMode =
	!setup.layout || setup.layout === "showcase" || setup.layout === 0;

const router = createBrowserRouter([
	{
		path: "/",
		element: (
			<LayoutProvider isShowcaseMode={isShowcaseMode}>
				<DynamicLayout>
					<Outlet />
				</DynamicLayout>
			</LayoutProvider>
		),
		children: [
			{ index: true, element: <HomePage /> },
			{ path: "resultados", element: <ResultsPage /> },
			{ path: "exames-duvidas", element: <ExamsFaqPage /> },
			{ path: "convenios", element: <AgreementsPage /> },
		],
	},
]);

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<RouterProvider router={router} />
	</StrictMode>,
);
